/** Message catalogue for the services pages (merged into the global catalogues). */
export const svcEn = {
  'svc.ill.title': 'Interlibrary loans',
  'svc.ill.description': 'Borrowing requests and their workflow.',
  'svc.erm.title': 'E-resources',
  'svc.events.title': 'Events and programmes',
  'svc.rooms.title': 'Rooms and equipment',
  'svc.engagement.title': 'Clubs and challenges',
} as const;

export const svcHi: Record<keyof typeof svcEn, string> = {
  'svc.ill.title': 'अंतर-पुस्तकालय ऋण',
  'svc.ill.description': 'उधार अनुरोध और उनका कार्यप्रवाह।',
  'svc.erm.title': 'ई-संसाधन',
  'svc.events.title': 'कार्यक्रम और आयोजन',
  'svc.rooms.title': 'कक्ष और उपकरण',
  'svc.engagement.title': 'क्लब और चुनौतियाँ',
};
